(function () {
  var brands = [
    {
      brandName: "6YE Doll",
      guideUrl: "/blogs/brand-introduction/the-guide-to-6ye-doll",
      description: "Est. 2013 TPE brand specializing in BBW & MILF dolls. Famous for anatomically correct positioning, flexible patented skeleton, and tear-resistant materials.",
      tagName: "",
      tagColor: "",
    },
    {
      brandName: "AI Tech Doll",
      guideUrl: "",
      description: "Where technology meets companionship — AI-powered robots that learn your preferences, express emotions, and feel human with 37°C heating and realistic TPE construction.",
      tagName: "",
      tagColor: "",
    },
    {
      brandName: "Aibei Doll",
      guideUrl: "/blogs/brand-introduction/the-guide-to-aibei-doll",
      description: "Est. 2017 TPE & silicone hybrid brand known for Thick & Busty figures. Wide range from Asian to Ebony to Elf dolls, with US & EU stock available for fast delivery.",
      tagName: "AFFORDABLE",
      tagColor: "#182be3",
    },
    {
      brandName: "Angelkiss Doll",
      guideUrl: "",
      description: "Born from WM Doll's expertise, AngelKiss delivers full silicone dolls with stunning skin texture, lifelike expressions, and innovative ROS & seamless neck options.",
      tagName: "",
      tagColor: "",
    },
    {
      brandName: "Chocolate Lady Doll",
      guideUrl: "",
      description: "A silicone doll brand dedicated to dark-skin aesthetics, offering tones from caramel to deep chocolate with layered skin coloring and realistic texture for a more natural complexion.",
      tagName: "NEW",
      tagColor: "#65b32e",
    },
    {
      brandName: "Climax Doll",
      guideUrl: "/blogs/brand-introduction/the-guide-to-climax-doll",
      description: "Est. 2016 brand specializing in thick BBW full-size dolls and torsos. Known for voluptuous figures and unique fantasy-style designs with a quirky twist.",
      tagName: "",
      tagColor: "",
    },
    {
      brandName: "Dolls Castle",
      guideUrl: "/blogs/brand-introduction/the-guide-to-dolls-castle",
      description: "Founded in 2016 by professional designers and manufacturers, delivering high-end realistic dolls worldwide. Custom options available with fast US & EU warehouse shipping.",
      tagName: "",
      tagColor: "",
    },
    {
      brandName: "Dreama Dolls",
      guideUrl: "",
      description: "A new brand launched in early 2026, offering hybrid dolls with silicone heads and TPE bodies across multiple heights and Asian/Western face styles, positioned for strong value and ready-to-ship options.",
      tagName: "NEW",
      tagColor: "#65b32e",
    },
    {
      brandName: "Doll Senior",
      guideUrl: "",
      description: "Founded in 2022, Doll Senior is an original doll brand known for its exquisite facial designs and natural body aesthetics. With delicate makeup, realistic full-body skin textures, and continuously evolving soft silicone technology, Doll Senior creates high-quality dolls that combine stunning visual appeal with lifelike softness and touch.",
      tagName: "NEW",
      tagColor: "#65b32e",
    },
    {
      brandName: "ElsaBabe Doll",
      guideUrl: "/blogs/brand-introduction/the-guide-to-elsa-babe",
      description: "Where anime meets reality — ElsaBabe crafts medical-grade silicone dolls with authentic anime features, unique furry heads, and lasting makeup. A must-have for collectors and anime fans.",
      tagName: "",
      tagColor: "",
    },
    {
      brandName: "Evas Doll",
      guideUrl: "/blogs/brand-introduction/the-guide-to-evas-doll",
      description: "A rising star launched in 2024, Evasdoll combines passionate craftsmanship with rapid innovation — already earning a devoted following and industry-wide recognition.",
      tagName: "",
      tagColor: "",
    },
    {
      brandName: "Fanreal Doll",
      guideUrl: "/blogs/brand-introduction/the-guide-to-fanreal-doll",
      description: "World-renowned boutique silicone dolls crafted to perfection. Fanreal's lifelike skin texture and body painting deliver one of the closest human-touch experiences in the industry.",
      tagName: "TOP",
      tagColor: "#f20a0a",
    },
    {
      brandName: "Firefly Diary Doll",
      guideUrl: "/blogs/brand-introduction/the-guide-to-firefly-diary-doll",
      description: "Est. 2023 brand with a unique 2.5D style blending anime charm with 3D realism. Each doll is a campus-themed character with its own personality and storyline — art that feels alive.",
      tagName: "NEW",
      tagColor: "#65b32e",
    },
    {
      brandName: "Funwest Doll",
      guideUrl: "/blogs/brand-introduction/the-guide-to-funwest-doll-5",
      description: "Premium TPE cosplay & anime dolls since 2021 — immersive fantasy designs with lifelike touch, interactive features, and budget-friendly prices perfect for first-time buyers.",
      tagName: "TOP",
      tagColor: "#f20a0a",
    },
    {
      brandName: "Galatea Doll",
      guideUrl: "",
      description: "Where myth meets craftsmanship — Galatea Doll creates premium lifelike dolls that embody beauty, realism, and artistic elegance for collectors and enthusiasts alike.",
      tagName: "",
      tagColor: "",
    },
    {
      brandName: "Galaxy Doll",
      guideUrl: "",
      description: "JX Doll's European & American series — same premium craftsmanship and realistic designs at an affordable price. Perfect balance of quality and value.",
      tagName: "",
      tagColor: "",
    },
    {
      brandName: "Game Lady Doll",
      guideUrl: "/blogs/brand-introduction/the-guide-to-game-lady-doll",
      description: "Where gaming culture meets ultimate craftsmanship — Game Lady creates 1:1 silicone replicas of iconic characters with breathtaking realism, perfect for collectors and fantasy enthusiasts.",
      tagName: "",
      tagColor: "",
    },
    {
      brandName: "Hime King Doll",
      guideUrl: "",
      description: "A rising premium silicone doll brand known for 172cm curvy figures and Eastern-inspired character styling, with lifelike skin texture, weight-reduction structure, and detailed makeup.",
      tagName: "NEW",
      tagColor: "#65b32e",
    },
    {
      brandName: "IDO Doll",
      guideUrl: "/blogs/brand-introduction/the-guide-to-i-do-doll",
      description: "Premium silicone dolls featuring Weight Reduction Technology 4.0 — 7-10kg lighter with 34-joint EVO skeleton, ROS, and food-grade silicone. Innovation and realism perfectly combined.",
      tagName: "TOP",
      tagColor: "#f20a0a",
    },
    {
      brandName: "Irontech Doll",
      guideUrl: "/blogs/brand-introduction/the-guide-to-irontech-doll",
      description: "Est. 2015 industry leader offering TPE & silicone dolls in BBW, Caucasian, and Black styles. Advanced robotic features include auto oral sex, waist twisting, and heating for ultimate realism.",
      tagName: "TOP",
      tagColor: "#f20a0a",
    },
    {
      brandName: "Jiusheng Doll",
      guideUrl: "/blogs/brand-introduction/the-guide-to-jiusheng-doll",
      description: "The master factory behind top brands like WM & JY Dolls. Jiusheng's sculptor-led team delivers platinum silicone heads, semi-permanent makeup, and ultra-flexible EVO skeletons since 2018.",
      tagName: "",
      tagColor: "",
    },
    {
      brandName: "JX Doll",
      guideUrl: "/blogs/brand-introduction/the-guide-to-jx-doll",
      description: "The ideal entry-level brand — OEM factory quality at unbeatable prices. Asian-style dolls with US & EU stock, correct LHP, and safe TPE & silicone materials.",
      tagName: "AFFORDABLE",
      tagColor: "#182be3",
    },
    {
      brandName: "Kiradols Doll",
      guideUrl: "",
      description: "A rising anime-style doll brand focused on fantasy character designs, soft silicone texture, movable oral features, and detailed makeup, wigs, and outfits for collectors who prefer expressive 2D-inspired looks.",
      tagName: "NEW",
      tagColor: "#65b32e",
    },
    {
      brandName: "Lily Doll",
      guideUrl: "",
      description: "Born from SEDOLL's expertise in 2024, Lily Doll pairs soft TPE/STPE bodies with silicone heads for beauty and comfort. Fully customizable from facial features to voice interaction and heating.",
      tagName: "NEW",
      tagColor: "#65b32e",
    },
    {
      brandName: "Lusandy Doll",
      guideUrl: "/blogs/brand-introduction/the-guide-to-lusandy-doll",
      description: "Where artistry meets innovation — Lusandy crafts fully customizable, lifelike dolls with premium materials and meticulous detail, setting new standards in the industry.",
      tagName: "",
      tagColor: "",
    },
    {
      brandName: "MMX Doll",
      guideUrl: "/blogs/brand-introduction/the-guide-to-mmx-doll",
      description: "Premium silicone art dolls backed by 30+ years of wax figure expertise. Led by a National Level 2 artist using Intangible Cultural Heritage painting techniques for unmatched realism.",
      tagName: "TOP",
      tagColor: "#f20a0a",
    },
    {
      brandName: "Mozu Doll",
      guideUrl: "",
      description: "Where 2D fantasy meets 3D reality — MOZU faithfully recreates iconic anime & game characters in TPE & silicone, complete with matching outfits for the ultimate collector's experience.",
      tagName: "",
      tagColor: "",
    },
    {
      brandName: "MRL Sex Doll",
      guideUrl: "",
      description: "An original anime and fantasy-style adult doll brand covering anime dolls, torsos, TPE/silicone products, and custom designs, with vivid character styling and diverse themed collections for collectors.",
      tagName: "NEW",
      tagColor: "#65b32e",
    },
    {
      brandName: "Notye Doll",
      guideUrl: "",
      description: "A premium brand specializing in silicone torsos and body-part customization, including hips, legs, and torso dolls with realistic proportions, customizable skin tones, and size options.",
      tagName: "NEW",
      tagColor: "#65b32e",
    },
    {
      brandName: "Orange in Doll",
      guideUrl: "",
      description: "A tech-forward silicone doll brand offering full silicone and TPE hybrid options, packed with interactive features including auto licking, oral heating, and responsive sucking systems.",
      tagName: "",
      tagColor: "",
    },
    {
      brandName: "Piper Doll",
      guideUrl: "",
      description: "Legendary designer Mizuwali's masterpiece — ultra-soft TPE & silicone dolls with charming anime faces, voluptuous curves, and an industry-exclusive seamless neck design.",
      tagName: "",
      tagColor: "",
    },
    {
      brandName: "Qita Doll",
      guideUrl: "",
      description: "The original pioneer of high-quality male sex dolls since 2016. Qita Doll's globally acclaimed designs set the standard for male doll craftsmanship worldwide.",
      tagName: "",
      tagColor: "",
    },
    {
      brandName: "Real Lady Doll",
      guideUrl: "/blogs/brand-introduction/the-guide-to-real-lady",
      description: "Premium silicone dolls crafted as 1:1 replicas of real human bodies with correct LHP. Every facial feature and body texture meticulously sculpted for the ultimate realism.",
      tagName: "",
      tagColor: "",
    },
    {
      brandName: "Realing Doll",
      guideUrl: "/blogs/brand-introduction/the-guide-to-realing-doll",
      description: "Founded in 2019 by Qita Doll creator Jupiter Gan, Realing specializes in premium male silicone dolls. Handsome faces, muscular builds, and fully customizable with medical-grade silicone construction.",
      tagName: "",
      tagColor: "",
    },
    {
      brandName: "Ridmii Doll",
      guideUrl: "",
      description: "Premium silicone, TPE, and hybrid dolls since 2018 — distinctive designs with app-controlled interaction, AI voice companionship, and lifelike detail for a more immersive experience.",
      tagName: "NEW",
      tagColor: "#65b32e",
    },
    {
      brandName: "SE Doll",
      guideUrl: "",
      description: "Crafted at the same Jinsan factory as WM Dolls, SE Doll offers unique original designs in TPE & silicone — especially loved for stunning head sculpts and signature elf-style dolls.",
      tagName: "",
      tagColor: "",
    },
    {
      brandName: "SHEDOLL",
      guideUrl: "/blogs/brand-introduction/the-guide-to-she-doll",
      description: "Where art meets innovation — SheDoll crafts hyper-realistic TPE & silicone companions with flexible steel skeletons, ultra-soft touch, and fully customizable features for a truly personal experience.",
      tagName: "NEW",
      tagColor: "#65b32e",
    },
    {
      brandName: "Sigafun Doll",
      guideUrl: "",
      description: "The silicone alternative to TPE torsos — backed by Irontech Doll's expertise, Sigafun offers softer, lighter, and more realistic silicone torsos in a wide range of styles.",
      tagName: "",
      tagColor: "",
    },
    {
      brandName: "Sino Doll",
      guideUrl: "",
      description: "Nearly a decade of silicone expertise, Sino-doll uses medical-grade platinum silicone with realistic painting to recreate pores, skin textures, and blood vessels for unmatched realism.",
      tagName: "NEW",
      tagColor: "#65b32e",
    },
    {
      brandName: "Starpery Doll",
      guideUrl: "/blogs/brand-introduction/the-guide-to-starpery-doll",
      description: "Known for striking Caucasian hyperrealism, Starpery's signature multi-layer painting recreates lifelike veins beneath the skin — available in full silicone or hybrid TPE & silicone builds.",
      tagName: "",
      tagColor: "",
    },
    {
      brandName: "SY Doll",
      guideUrl: "/blogs/brand-introduction/the-guide-to-sy-doll",
      description: "A rising TPE & silicone brand and pioneer of Real Oral Sex (ROS) technology. Wide range of body and head options with unique designs, good quality, and affordable prices.",
      tagName: "AFFORDABLE",
      tagColor: "#182be3",
    },
    {
      brandName: "Tantaly",
      guideUrl: "",
      description: "The world's leading torso doll brand — combining the realism of full-body dolls with the convenience of compact design. Premium TPE construction, globally trusted by 100,000+ customers.",
      tagName: "TORSO",
      tagColor: "#ff9800",
    },
    {
      brandName: "TOP-CYDOLL",
      guideUrl: "/blogs/brand-introduction/the-guide-to-top-cydoll",
      description: "A pioneer in silicone doll manufacturing with 10+ years of expertise — TOP-CYDOLL creates more than dolls; each piece is a timeless work of art and a lifelong companion.",
      tagName: "",
      tagColor: "",
    },
    {
      brandName: "Top Fire Doll",
      guideUrl: "/blogs/brand-introduction/the-guide-to-top-fire-doll",
      description: "A new high-end silicone brand backed by 20+ years of expertise. Western designer collaborations and pioneering robotic features make Top Fire Doll one to watch.",
      tagName: "",
      tagColor: "",
    },
    {
      brandName: "WM Dolls",
      guideUrl: "/blogs/brand-introduction/the-guide-to-wm-doll",
      description: "The industry pioneer since 2012 — WM Dolls offers 400+ head designs in premium TPE, silicone, and S-TPE, setting the gold standard for quality and variety worldwide.",
      tagName: "",
      tagColor: "",
    },
    {
      brandName: "XT Doll",
      guideUrl: "/blogs/brand-introduction/the-guide-to-xt-doll",
      description: "XT Doll's game-changing tech sets it apart — responsive feedback legs, Zero Backward Thrust Vagina, and super lightweight construction redefine what a silicone & hybrid doll can deliver.",
      tagName: "",
      tagColor: "",
    },
    {
      brandName: "YL Doll",
      guideUrl: "",
      description: "A Jinsan factory exclusive brand offering unmatched variety — from athletic tall bodies to ultra-large bust sizes up to P-cup. Soft TPE construction with wide customization options for every preference.",
      tagName: "",
      tagColor: "",
    },
    {
      brandName: "YUE Doll",
      guideUrl: "",
      description: "Premium smart companion dolls with integrated silicone bodies and detachable AI head modules — combining bionic materials, voice interaction, emotional responses, and precise craftsmanship for a more lifelike companionship experience.",
      tagName: "NEW",
      tagColor: "#65b32e",
    },
    {
      brandName: "Yeloly Doll",
      guideUrl: "",
      description: "Founded in 2023, Yeloly Doll is a premium silicone torso doll brand focused on lifelike skin texture, lightweight structure, LHP/ROS design, and flexible appearance customization.",
      tagName: "NEW",
      tagColor: "#65b32e",
    },
    {
      brandName: "Zelex Doll",
      guideUrl: "/blogs/brand-introduction/the-guide-to-zelex-doll",
      description: "Est. 2017 silicone brand renowned for premium quality at unbeatable value. Inspiration series features movable jaw, interchangeable labia, and softer touch — the best silicone dollar-for-dollar.",
      tagName: "TOP",
      tagColor: "#f20a0a",
    },
  ];

  window.getNewHeader3Brands = function () {
    return brands.slice();
  };

  function normalizeName(value) {
    return String(value || "")
      .trim()
      .toLowerCase();
  }

  function findBrand(brandName) {
    var normalizedName = normalizeName(brandName);
    return brands.find(function (brand) {
      return normalizeName(brand.brandName) === normalizedName;
    });
  }

  function setMeta(trigger, brand) {
    var tagMeta = trigger.querySelector("[data-brand-tag]");
    var guideMeta = trigger.querySelector("[data-brand-guide]");
    if (!brand) return;

    if (tagMeta) tagMeta.innerHTML = "";
    if (guideMeta) guideMeta.innerHTML = "";

    if (brand.tagName && tagMeta) {
      var tag = document.createElement("span");
      tag.className = "new-header-brands__tag";
      tag.textContent = brand.tagName;
      tag.style.backgroundColor = brand.tagColor || "#ec2b7b";
      tagMeta.appendChild(tag);
    }

    if (brand.guideUrl && guideMeta) {
      var guide = document.createElement("span");
      guide.className = "new-header-brands__guide-pill";
      guide.textContent = "Guide";
      guideMeta.appendChild(guide);
    }
  }

  function setActiveBrand(root, trigger, brand) {
    var brandName = trigger.dataset.brandName || "";
    var brandUrl = trigger.dataset.brandUrl || "#";
    var productTemplate = document.getElementById(trigger.dataset.brandProductsId || "");
    var title = root.querySelector("[data-brand-detail-title]");
    var guideLink = root.querySelector("[data-brand-detail-guide]");
    var viewAllLink = root.querySelector("[data-brand-detail-view-all]");
    var description = root.querySelector("[data-brand-detail-description]");
    var products = root.querySelector("[data-brand-detail-products]");

    root.querySelectorAll(".new-header-brands__trigger.is-active").forEach(function (activeTrigger) {
      activeTrigger.classList.remove("is-active");
    });
    trigger.classList.add("is-active");

    if (title) title.textContent = brandName;

    if (guideLink) {
      if (brand && brand.guideUrl) {
        guideLink.href = brand.guideUrl;
        guideLink.classList.add("is-visible");
      } else {
        guideLink.href = "#";
        guideLink.classList.remove("is-visible");
      }
    }

    if (viewAllLink) {
      viewAllLink.href = brandUrl;
      viewAllLink.textContent = "View All " + brandName;

      var viewAllArrow = document.createElement("span");
      viewAllArrow.className = "new-header-brands__view-all-arrow";
      viewAllArrow.setAttribute("aria-hidden", "true");
      viewAllArrow.textContent = "\u2192";
      viewAllLink.appendChild(viewAllArrow);
    }

    if (description) {
      description.textContent = brand && brand.description ? brand.description : "";
    }

    if (products) {
      products.innerHTML = productTemplate && productTemplate.innerHTML.trim()
        ? productTemplate.innerHTML
        : '<p class="new-header-brands__empty">No preview products found for this brand yet.</p>';
    }
  }

  function initBrandMenu(root) {
    var triggers = Array.prototype.slice.call(root.querySelectorAll(".new-header-brands__trigger"));
    if (!triggers.length) return;

    triggers.forEach(function (trigger) {
      var brand = findBrand(trigger.dataset.brandName);
      setMeta(trigger, brand);

      trigger.addEventListener("mouseenter", function () {
        setActiveBrand(root, trigger, brand || {});
      });

      trigger.addEventListener("focus", function () {
        setActiveBrand(root, trigger, brand || {});
      });
    });

    setActiveBrand(root, triggers[0], findBrand(triggers[0].dataset.brandName) || {});
  }

  function initBrandMenus() {
    document.querySelectorAll("[data-new-header-brands]").forEach(initBrandMenu);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initBrandMenus);
  } else {
    initBrandMenus();
  }
})();
